module.exports = __webpack_public_path__ + "img/COR_Logo.b65868b3.png";